import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface ConfirmResult {
  accepted: boolean;
  reasonId: string;
}
export interface ConfirmDialogWithDictData {
  text: string;
  dictType: string;
  label: string;
}

@Component({
  selector: 'app-confirm-dialog-with-dict',
  templateUrl: './confirm-dialog-with-dict.component.html',
  styleUrls: ['./confirm-dialog-with-dict.component.scss']
})
export class ConfirmDialogWithDictComponent {
  text = '';
  reasonControl: FormControl;
  label = '';
  dictType = null;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogWithDictComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogWithDictData,
    private fb: FormBuilder,
  ){
    this.text = data.text;
    this.label = data.label;
    this.dictType = data.dictType;
    this.reasonControl = fb.control('');
  }

  confirm(): void {
    this.dialogRef.close({
      accepted: true,
      reasonId: this.reasonControl.value
    });
  }

  decline(): void {
    this.dialogRef.close({
      accepted: false,
      reasonId: ''
    });
  }

}
